import React from 'react';
import { AppPromoImage } from './AppPromoImage';

/**
 * "Así es la app por dentro". El asset ya trae ese título,
 * por eso la sección no agrega ningún texto.
 */
export function AppShowcase() {
  return <section id="la-app" aria-label="Así es la app por dentro" className="bg-cream" data-id="element-16" data-mp="21kn2pjrdyo3w">
      <AppPromoImage data-id="element-17" data-mp="1xi9y4yodkw8p" />
    </section>;
}